"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragNDropHandler = exports.ScrollableTableContainer = void 0;
const styles_1 = require("@mui/material/styles");
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
exports.ScrollableTableContainer = (0, styles_1.styled)(TableContainer_1.default)({
    maxHeight: "calc(100vh - 180px)",
    overflowY: "scroll",
});
exports.DragNDropHandler = (0, styles_1.styled)("td", {
    shouldForwardProp: (prop) => prop !== "isDragging",
})(({ theme, isDragging }) => ({
    color: isDragging
        ? theme.palette.institutional.braskemCyan
        : theme.palette.grayScale.gray4,
    padding: "0 12px",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
}));
